export const REDUCER_NAME = 'treatment'

export const CURRENCY_CODE_LIST = [
    {
        id: 'CHF',
        value: 'CHF',
    },
    {
        id: 'EUR',
        value: 'EUR',
    },
    {
        id: 'GBP',
        value: 'GBP',
    },
    {
        id: 'SEK',
        value: 'SEK',
    },
    {
        id: 'DKK',
        value: 'DKK',
    },
]

export const CURRENCY_CODE_SYMBOL = {
    CHF: 'fa fa-money',
    EUR: 'fa fa-euro',
    GBP: 'fa fa-gbp',
    SEK: 'fa fa-krw',
}

export const AVAILABLE_IMPLANT_TREATMENT_PRICE_LIST = [
    {
        id: 199900,
        value: '1999,00',
    },
    {
        id: 399800,
        value: '3998,00',
    },
    {
        id: 569700,
        value: '5697,00',
    },
    {
        id: 719600,
        value: '7196,00',
    },
    {
        id: 849500,
        value: '8495,00',
    },
]

export const AVAILABLE_TREATMENT_PRICE_LIST = [

    // new and sorted prices
    {
        id: 20000,
        value: '200,00',
    },
    {
        id: 99000,
        value: '990,00',
    },
    {
        id: 104950,
        value: '1049,50',
    },
    {
        id: 109000,
        value: '1090,00',
    },
    {
        id: 119000,
        value: '1190,00',
    },
    {
        id: 129000,
        value: '1290,00',
    },
    {
        id: 139000,
        value: '1390,00',
    },
    {
        id: 149000,
        value: '1490,00',
    },
    {
        id: 159000,
        value: '1590,00'
    },
    {
        id: 169000,
        value: '1690,00',
    },
    {
        id: 169900,
        value: '1699,00',
    },
    {
        id: 179000,
        value: '1790,00',
    },
    {
        id: 189000,
        value: '1890,00',
    },
    {
        id: 189900,
        value: '1899,00',
    },
    {
        id: 199000,
        value: '1990,00',
    },
    {
        id: 209000,
        value: '2090,00',
    },
    {
        id: 215100,
        value: '2151,00',
    },
    {
        id: 219000,
        value: '2190,00',
    },
    {
        id: 219900,
        value: '2199,00',
    },
    {
        id: 229000,
        value: '2290,00',
    },
    {
        id: 239000,
        value: '2390,00',
    },
    {
        id: 249000,
        value: '2490,00',
    },
    {
        id: 249900,
        value: '2499,00',
    },
    {
        id: 251100,
        value: '2511,00',
    },
    {
        id: 259000,
        value: '2590,00',
    },
    {
        id: 269000,
        value: '2690,00',
    },
    {
        id: 269100,
        value: '2691,00',
    },
    {
        id: 279000,
        value: '2790,00',
    },
    {
        id: 289000,
        value: '2890,00',
    },
    {
        id: 299000,
        value: '2990,00',
    },
    {
        id: 309000,
        value: '3090,00',
    },
    {
        id: 319000,
        value: '3190,00',
    },
    {
        id: 349000,
        value: '3490,00',
    },
    {
        id: 1628500,
        value: '16285,00',
    },
    {
        id: 1926000,
        value: '19260,00',
    },
    {
        id: 2074500,
        value: '20745,00',
    },
    {
        id: 2399000,
        value: '23990,00',
    },
    {
        id: 2799000,
        value: '27990,00',
    },
    {
        id: 2999000,
        value: '29990,00',
    },
]

export const IMPLANT_TREATMENT_PHYSICIAN_COST = 0



// WEBPACK FOOTER //
// ./src/modules/treatment/state/const.js